import { useEffect, useRef, useState } from 'react';
import { FaLock, FaSignOutAlt } from 'react-icons/fa';

function normalizeText(value) {
  return String(value ?? '').replace(/\s+/g, ' ').trim();
}

export default function AccountPanel({ profile, loading, error, onOpenSecurity, onOpenLogout }) {
  const panelRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const displayName = normalizeText(profile?.fullName || 'Usuario').toUpperCase();
  const displayRole = normalizeText(profile?.roleLabel || 'Usuario').toUpperCase();
  const displayInitials = normalizeText(profile?.initials || 'US');

  useEffect(() => {
    if (!menuOpen) {
      return undefined;
    }

    const handleOutsideClick = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    };
  }, [menuOpen]);

  return (
    <div ref={panelRef} className="relative">
      {menuOpen ? (
        <div className="absolute bottom-full left-0 right-0 z-20 mb-3 overflow-hidden rounded-xl border border-slate-200 bg-white text-slate-800 shadow-2xl">
          <button
            type="button"
            onClick={() => {
              setMenuOpen(false);
              onOpenSecurity();
            }}
            className="flex w-full items-center gap-3 px-4 py-3 text-left text-sm font-semibold transition hover:bg-slate-50"
          >
            <FaLock className="text-slate-500" size={14} />
            Seguridad
          </button>
          <button
            type="button"
            onClick={() => {
              setMenuOpen(false);
              onOpenLogout();
            }}
            className="flex w-full items-center gap-3 border-t border-slate-100 px-4 py-3 text-left text-sm font-semibold text-red-600 transition hover:bg-red-50"
          >
            <FaSignOutAlt size={14} />
            Cerrar sesión
          </button>
        </div>
      ) : null}

      <button
        type="button"
        onClick={() => setMenuOpen((prev) => !prev)}
        className="w-full rounded-lg border border-red-400/70 bg-red-500 p-3 text-left text-white shadow-md transition hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-white/25"
        aria-label="Abrir opciones de cuenta"
        aria-haspopup="menu"
        aria-expanded={menuOpen}
      >
        <div className="flex items-start gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-white/20 bg-red-700/40 text-sm font-bold text-white">
            {loading ? '...' : displayInitials}
          </div>

          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold leading-5 text-white">
              {loading ? 'Cargando usuario...' : displayName}
            </p>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.24em] text-red-100">
              {loading ? 'SINCRONIZANDO' : displayRole}
            </p>
            {error ? <p className="mt-2 text-[11px] text-red-100/95">Perfil en modo respaldo</p> : null}
          </div>
        </div>
      </button>
    </div>
  );
}